import React from 'react';
import './loader.scss';

const Loader = () => {

  return (
    <div className="loader spinner-border" role="status">
      <span className="visually-hidden">Chargement...</span>
    </div>
)};

export default Loader;
